import * as React from 'react';
import { Component } from 'react';
import '../../temp.css';

export class TemporaryComponent extends Component {

    constructor(props) {
        super(props);

    }

    public render() {
        return (
            <div className="temporary-component content topmargin">
                <img src="https://znajdzfizjoterapeute.pl/assets/logo-full-2x.png" />
                <h1>Dostępny wkrótce</h1>
                <div className="redirect-button-container">
                    <h4>Jeśli jesteś fizjoterapeutą...</h4>
                    <a href="https://logowanie.kif.info.pl/register">Załóż profil na Znajdź Fizjoterapeutę</a>
                </div>
                <div className="search-view">
                    <div className="search-view-container">
                        <div className="search-view-card-1" />
                        <div className="search-view-card-2" />
                        <div className="search-view-card-3" />
                        <div className="search-view-card-4" />
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Layout/Temporary.tsx